import React from "react";
import { useState,useEffect } from "react";
import { Helmet } from 'react-helmet';
import SalespersonSidebar from "./SalespersonSidebar";
import './classes/ScoutRequestReportView.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';

const ScoutRequestReportView = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [toggle, setToggle] = useState(1);
    const [data, setData] = useState({});
    const [nextId, setNextId] = useState({});
    const [prevId, setPrevId] = useState({});
    const [errors, setErrors] = useState({});
    
    const [scoutPicture, setScoutPicture] = useState({});
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
      const location = useLocation();
        const drupal_uid = localStorage.getItem('drupal_uid');
        const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
        var loggedin_domain = drupal_domain_url;
        if(localStorage.getItem('loggedin_domain')) {
        loggedin_domain = localStorage.getItem('loggedin_domain');
        } 
        const {sid} = useParams();
        const navigate = useNavigate();
        const app_url = configData.APP_URL;


    const updateToggle = (id) => {
        setToggle(id);
        if(id == 1) { 
            navigate("/node/841/submission/"+sid);
        }
        if(id == 2) { 
            navigate("/node/841/submission/"+sid+"/edit");
        } 
        if(id == 3) { 
            navigate("/node/841/submission/"+sid+"/delete");
        }
    }
        
    useEffect(() => {
            Promise.all([
                getscoutrequestview(),
                retrieveUserLoggedinroles(),
            ])
            .then(() => {
            
                setIsLoading(false);
            })
            
        },[]);
  // All data 
  // const submissionData = {
  //   formName: "Scouting Requests",
  //   submittedBy: "Anonymous (not verified)",
  //   submittedDate: "Fri, 2025-06-06 06:00",
  //   ipAddress: "103.103.237.252",
  //   player: {
  //     "report-individual": { label: "Player's First Name", data: "TestMintu" },
  //     "players-last-name": { label: "Player's Last Name", data: "Kittu" },
  //     "players-age": { label: "Player's Age", data: "22" },
  //     "sport-played": { label: "Player's Sport", data: "Football (American)" },
  //     "currently-playing-for": { label: "Team Which the Player is On", data: "TEST" },
  //     "position-played": { label: "Player's Position", data: "BB" },
  //     "players-country": { label: "Where to Scout the Player", data: "United States" },
  //     "players-state": { label: "Player's State", data: "Oregon" },
  //     "players-ranking-website": { label: "Link to a Website(s) That Shows the Player's Ranking", data: "" },
  //     "players-video-link": { label: "Links to Any Highlight Videos", data: "" },
  //   },
  //   requester: {
  //     "first-name": { label: "First Name", data: "TestPatel" },
  //     "last-name": { label: "Last Name", data: "Raotest" },
  //     "email": { label: "Email", data: "raopateltest@preferati.com" },
  //     "phone": { label: "Phone Number", data: "5036984758" },
  //     "street-address": { label: "Street Address", data: "Portland" },
  //     "relationship-with-player": { label: "Relationship with Player", data: "SMWW Agent Advisor" },
  //     "are-you-an-smww-agent-advisor": { label: "Are You an SMWW Agent Advisor", data: "Yes" },
  //     "notes": { label: "Notes", data: "" },
  //   },
  //   userId: "881569",
  // };

  const {
    formName,
    submittedBy,
    submittedDate,
    ipAddress,
    player,
    requester,
    userId,
  } = data;
async function getscoutrequestview() {
        const response = await fetch(
          app_url+'smwwscout/getscoutrequestview?sid='+sid,
          {
            method: "GET",
      
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )           
        const responsedata = await response.json();
          if(responsedata.data.msg === "Success") {
          setData(responsedata.data.result);
          setScoutPicture(responsedata.data.picture);
          setNextId(responsedata.data.next_id);
          setPrevId(responsedata.data.prev_id);
        }
          if(responsedata.data.msg === "Error") {
             setErrors(responsedata.data.result);
          } 
        }
      
    async function retrieveUserLoggedinroles() {
        try {
            setIsLoading(true);
            const response = await fetch(
            app_url+'viewprofile/getuserloggedinrolesid',
            {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                },
            }
            )
            const responsedata = await response.json();
            if(responsedata.data.result === "Success") {
            setUserLoggedInRoles(responsedata.data.roles)
            }
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
                
        }
    }

  return (
     <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">
                  <Helmet>
                      <title>Submission #{sid}</title>
                  </Helmet>
            <div className="left"></div>
            <div className="center left-center">
                 {Object.values(errors).some(msg => !!msg) && (
                                  <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                                    <ul>
                                      {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                          <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                        <>
                            {/* {successMessage && (
                            <div className="set-message-done">
                            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                            </div>
                            )} */}
                            <div className='button_wrap'>
                                <ul className="tabs primarya">
                                    <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View</a></li>
                                    {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) && 
                                    <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit</a></li>}
                                    <li className= {toggle === 3? "active" : ""} onClick={()=> updateToggle(3)}><a>Delete</a></li>
                                </ul>      
                            </div>
                            {/* <div  className= {toggle === 1? "show-content" : "content"}>
                                <ScoutRequestReportView />
                            </div> */}
                         </>
                        }
              <div className="scout-report-view-container">
     {/* Top Navigation */}
<nav>
  {/* <a href="#">Previous submission</a>
  <a href="#">Next submission</a> */}
{prevId &&
    <a href={"/node/841/submission/"+prevId}>Previous submission</a>
}
{nextId &&
    <a href={"/node/841/submission/"+nextId}>Next submission</a>
}
</nav>
<div style={{clear: "both"}}></div>
<fieldset>
    <legend>Submission information</legend>
    <div>
        <div className="scout-user-picture">
            {(data?.user_url) ?
            (<a href={data.user_url} title="View user profile.">
            <img
                src={scoutPicture}
                alt="User profile"
            />
            </a>) : (
            <img
                src={scoutPicture}
                alt="User profile"
            />
            )}
        </div>
        <div>Form: <a href={"https://"+configData.RSMWW_SCOUT_DOMAIN+"/scouting-requests"}>{formName}</a></div>
        <div>Submitted by 
            {(data?.submittedBy) ? (
                <a href={data.user_url} title="View user profile.">
                    <span> {submittedBy}</span>
                </a>
            ) : (
                <span> {submittedBy}</span>
            )}
        </div>        
        <div>{submittedDate}</div>
        <div>{ipAddress}</div>
    </div>
</fieldset>

{/* Player Info */}
<h2>Player Information</h2>
{player && Object.entries(player).map(([key, value]) => (
  <div key={key} className="form-item">
    <label>{value.label}</label>
    <span>{value.data || <em>—</em>}</span>
  </div>
))}

{/* Requester Info */}
<h2>Requester Information</h2>
{requester && Object.entries(requester).map(([key, value]) => (
  <div key={key} className="form-item">
    <label>{value.label}</label>
    <span>{value.data || <em>—</em>}</span>
  </div>
))}
{/* User ID */}
<div className="form-item">
  <label>User ID</label>
  <span>{userId || <em>—</em>}</span>
</div>

{/* Bottom Navigation */}
<nav>
  {/* <a href="#">Previous submission</a>
  <a href="#">Next submission</a> */}
{prevId &&
    <a href={"/node/841/submission/"+prevId}>Previous submission</a>
}
{nextId &&
    <a href={"/node/841/submission/"+nextId}>Next submission</a>
}
</nav>
</div>
    </div>

 
            <div className="right">
                <SalespersonSidebar />
            </div>
        </div>
            )}
            </>
    );
};

export default ScoutRequestReportView;
